export class MapDimensionsModel{
  width: number = 0;
  height: number = 0;
  x: number = 0;
  y: number = 0;
}
